import { createDynamicSlice } from ".";
import { reportsAnalyticsOrderThunk, reportsAnalyticsProductsThunk, reportsAnalyticsStockInfoThunk } from "../thunks/reportsAnalyticsThunk";

const reportsAnalyticsOrderSlice = createDynamicSlice({
  name: "reportsAnalyticsOrderSlice",
  thunk: reportsAnalyticsOrderThunk,
});

const reportsAnalyticsStockInfoSlice = createDynamicSlice({
  name: "reportsAnalyticsStockInfoSlice",
  thunk: reportsAnalyticsStockInfoThunk,
  listMode:true
});

const reportsAnalyticsProductsSlice = createDynamicSlice({
  name: "reportsAnalyticsProductsSlice",
  thunk: reportsAnalyticsProductsThunk,
  listMode: true
});


export const reportsAnalyticsOrderReducer = reportsAnalyticsOrderSlice.reducer;
export const reportsAnalyticsStockInfoReducer = reportsAnalyticsStockInfoSlice.reducer;
export const reportsAnalyticsProductsReducer = reportsAnalyticsProductsSlice.reducer;